exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-js .vjs-live-control {\n    padding-left: 10px !important;\n}", ""]);

// exports
